import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f261f0a2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "openboxlist"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "开盲盒", -1));
const _hoisted_5 = {
  class: "box"
};
const _hoisted_6 = {
  class: "ul"
};
const _hoisted_7 = {
  class: "img"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "name"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
    class: "back",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.close && $options.close(...args))
  }), _hoisted_4])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, (item, idx) => {
    return _openBlock(), _createElementBlock("div", {
      class: "li",
      key: idx
    }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
      class: _normalizeClass(['unpacking_type', 'unpacking_type' + item.unpacking_type])
    }, " 隐藏款 ", 2), _createElementVNode("img", {
      src: item.unpacking_icon,
      alt: ""
    }, null, 8, _hoisted_8)]), _createElementVNode("div", _hoisted_9, _toDisplayString(item.unpacking_name), 1)]);
  }), 128))])]), _createElementVNode("div", {
    class: "bt",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.toProject && $options.toProject(...args))
  }, "再来一单")]);
}